import React, { useState } from 'react';
import { postProximity } from '../API/routePlannerAPI'; // Import the API function

// Function to get color based on distance
function getDistanceColor(distance) {
    if (distance <= 3000) return 'green';      // 1-3 km in meters
    if (distance <= 5000) return '#FF8C00';     // 4-5 km in meters
    return 'red';                              // 6 km and above
}

const ProximityChecker = () => {
    const [startLocation, setStartLocation] = useState('');
    const [destinations, setDestinations] = useState(Array(10).fill(''));
    const [proximityData, setProximityData] = useState(null);
    const [error, setError] = useState('');

    // Handle change for destination inputs
    const handleDestinationChange = (index, value) => {
        const newDestinations = [...destinations];
        newDestinations[index] = value;
        setDestinations(newDestinations);
    };

    const handleCheckProximity = async () => {
        setError('');
        setProximityData(null);

        try {
            // Filter out any empty destination fields
            const filledDestinations = destinations.filter(dest => dest.trim() !== '');

            // Validate input fields
            if (!startLocation) {
                setError("Please enter a valid start ZIP code.");
                return;
            }
            if (filledDestinations.length === 0) {
                setError("Please enter at least one destination ZIP code.");
                return;
            }

            // Call API function
            const data = await postProximity(startLocation, filledDestinations);

            // Debug: Check source and destinations data
            console.log("Source data:", data.source);
            console.log("Destinations data:", data.destinations);

            // Ensure data has expected structure
            if (!data || !data.source || !Array.isArray(data.destinations)) {
                setError("Unexpected data structure from API");
                return;
            }

            // Sort the proximity data by distance (nearest to farthest)
            const sortedDestinations = data.destinations.sort((a, b) => a.distance - b.distance);
            
            // Set proximity data with sorted destinations
            // Set proximity data with sorted destinations
            setProximityData({
                source: data.source,
                destinations: sortedDestinations
            });
        } catch (err) {
            setError('Failed to retrieve proximity data');
            console.error("Error in handleCheckProximity:", err);
        }
    };

    return (
        <div className="proximity-checker">
            <h1>Proximity Checker</h1>
            
            <label>Source ZIP Code:</label>
            <input
                type="text"
                placeholder="Enter source ZIP code"
                value={startLocation}
                onChange={(e) => setStartLocation(e.target.value)}
            />

            <h3>Enter up to 10 destination ZIP codes:</h3>
            {destinations.map((dest, index) => (
                <input
                    key={index}
                    type="text"
                    placeholder={`Destination ZIP code ${index + 1}`}
                    value={dest}
                    onChange={(e) => handleDestinationChange(index, e.target.value)}
                    style={{ marginTop: '5px' }}
                />
            ))}

            <button onClick={handleCheckProximity} style={{ marginTop: '15px' }}>
                Check Proximity
            </button>

            {error && <p style={{ color: 'red' }}>{error}</p>}

            {proximityData && (
                <>
                    <h2>Source Location:</h2>
        <p>        
            <strong>Barangay:</strong> {proximityData.source?.province || 'N/A'} <br />
            <strong>City:</strong> {proximityData.source?.city || 'N/A'} <br />            
            <strong>ZIP Code:</strong> {proximityData.source?.zipcode || 'N/A'} 
        </p>

        <h2>Proximity Data (Nearest to Farthest):</h2>
        <ul>
            {proximityData.destinations.map((data, index) => (
                <li 
                    key={index} 
                    style={{ color: getDistanceColor(data.distance) }} // Apply color based on distance
                >
                    <strong>Destination {index + 1}:</strong> {data.province || 'Unknown'},  {data.city || 'Unknown'}
                    (ZIP: {data.zipcode || 'N/A'}) <br />
                    Distance: {(data.distance / 1000).toFixed(2)} km, 
                    Duration: {data.duration.toFixed(1)} mins at {data.speedKmH} km/h
                </li>
            ))}
        </ul>
                    		
                </>
            )}
        </div>
    );
};

export default ProximityChecker;
